import def from './default.json';
import prod from './production.json';

export default (process.env.NODE_ENV === 'production' ? prod : def);
